import { RainbowKitProvider, lightTheme } from "@rainbow-me/rainbowkit";
import "@rainbow-me/rainbowkit/styles.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { ReactElement } from "react";
import { WagmiProvider } from "wagmi";
import { ConnectWalletAnalytics } from "@/components";
import { wagmiConfig } from "@/config";
import { withClientOnly } from "@/hoc";

const queryClient = new QueryClient({});

const theme = lightTheme({
    accentColor: "rgb(var(--color-primary))",
    accentColorForeground: "white",
    borderRadius: "small",
    // @ts-ignore - RainbowKit's theme function is not typed to accept our custom CSS variables, but it works at runtime
    fontStack: "var(--font-sans)",
    overlayBlur: "small",
});

export const Web3Provider = withClientOnly(({ children }: { children: ReactElement }) => {
    return (
        <WagmiProvider config={wagmiConfig}>
            <QueryClientProvider client={queryClient}>
                <RainbowKitProvider theme={theme}>
                    <ConnectWalletAnalytics />
                    {children}
                </RainbowKitProvider>
            </QueryClientProvider>
        </WagmiProvider>
    );
});
